import { useContext } from 'react';
import { useAuthenticated } from 'react-admin';

import { AppContext } from '@app/contexts';
import { useGenericList } from '@app/hooks/useGenericList';
import { CASLAction, useAbility } from '@app/utils/authUtils';
// import { useGenericList } from '@app/hooks/useGenericList';
import { getFieldOnMainLanguage } from '@app/utils/languages';

import { GenericList } from '@app/components/common/GenericList';
import { ColumnTypes, GenericObject } from '@app/components/common/Table/DefaultTable/types';

export const ListEvents = () => {
  const { handleChangeLoading } = useContext(AppContext);

  const { isLoading, data, total, handleChangeFilters, handleChangeSort, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    useGenericList('events');

  /**
   * List[X] pages require manual auth check for some reason.
   * This involves the `checkAuth` method in auth.ts.
   */
  useAuthenticated();
  const ability = useAbility();

  const columns = [
    {
      label: 'TITLE',
      key: 'title',
      type: ColumnTypes.DEFAULT,
      format: (row: GenericObject) => `${getFieldOnMainLanguage(row?.title)}`,
      sort: (order: string) => {
        handleChangeSort({ field: 'event.title', order });
      },
    },
    {
      label: 'SERIES',
      key: 'series',
      type: ColumnTypes.DEFAULT,
    },
    {
      label: 'DATE',
      key: 'event_date',
      type: ColumnTypes.DATE,
    },
    {
      label: 'REGISTRATION URL',
      key: 'registration_url',
      type: ColumnTypes.DEFAULT,
    },
    {
      label: 'EVENT URL',
      key: 'event_url',
      type: ColumnTypes.DEFAULT,
    },
  ];

  if (ability.can(CASLAction.WRITE, 'events')) {
    columns.push({
      label: 'PUBLISHED',
      key: 'is_published',
      type: ColumnTypes.STATUS,
      // @ts-ignore this is definitely valid
      publishedKey: 'status',
      isPublished: (row: GenericObject) => row.status === 'ACTIVE',
      getNewPublishedStatus: (row: GenericObject) => (row.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'),
    });
  }

  return (
    <GenericList
      isListLoading={isLoading}
      rows={data}
      generalFilterKey={'name'}
      resourceSingular="event"
      handleChangeLoading={handleChangeLoading}
      columns={columns}
      resource="events"
      title="Events"
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangePage={handleChangePage}
      total={total}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      handleChangeFilters={handleChangeFilters}
    />
  );
};
